// Native & external imports
import { Pipe, PipeTransform, inject } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({ name: "safeHtml", standalone: false })
export class SafeHtmlPipe implements PipeTransform {
  private sanitized = inject(DomSanitizer);

  transform(value: string) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
